import { useDocumentTitle } from '../hooks/useDocumentTitle';
import { Heading } from '../components_catalyst/heading';
import { Text } from '../components_catalyst/text';
import { Link } from '../components_catalyst/link';

export function ContactPage() {
  useDocumentTitle('Contact Us', { addSuffix: true });

  return (
    <main className="max-w-4xl mx-auto space-y-6 p-4">
      <Heading level={1}>Contact Us</Heading>

      <div className="space-y-4">
        <Text>
          Looking to get in touch with the MilestoneMap.org team?{' '}
          <Link
            href="https://forms.gle/shicvZq1JzEq6pABA"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:text-blue-800 underline decoration-2 decoration-blue-600/30 hover:decoration-blue-800"
            aria-label="Open contact form in new tab"
          >
            Drop us a note here
          </Link>
          . Someone will be in touch shortly.
        </Text>
      </div>
    </main>
  );
}
